var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBtfTimetable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dfbad295-0b7f-4868-98fb-8f43f37c0ce6",
    d: "M26 4v28H5V4h21zm-2.194 2.227H7.194v23.546h16.612V6.227zM21.818 0v2.227H2.728L2.726 28H.5V0h21.318zM11.5 22.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm8.5 0a1 1 0 0 1 0 2h-4.216a1 1 0 1 1 0-2H20zM11.5 16a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm8.5 0a1 1 0 0 1 0 2h-4.216a1 1 0 1 1 0-2H20zm-8.5-7.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm8.5 0a1 1 0 0 1 0 2h-4.216a1 1 0 1 1 0-2H20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3.246)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bdfbad295-0b7f-4868-98fb-8f43f37c0ce6",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dfbad295-0b7f-4868-98fb-8f43f37c0ce6"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#dfbad295-0b7f-4868-98fb-8f43f37c0ce6"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    mask: "url(#bdfbad295-0b7f-4868-98fb-8f43f37c0ce6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3 0h32v32H-3z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtfTimetable);
export default __webpack_public_path__ + "static/media/btf-timetable.eaa0781f3d9f544a8ab118cdec45ebcd.svg";
export { ForwardRef as ReactComponent };